import React, { useEffect, useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { dataRaw } from "../data-summary.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  scales: {
    x: {
      ticks: {
        precision: 0,
        color: "#d7d7d7",
      },
      grid: {
        color: "#4b4b4b",
      },
    },
    y: {
      ticks: {
        precision: 0,
        color: "#d5d5d5",
      },
      grid: {
        color: "#4b4b4b",
      },
    },
  },
  plugins: {
    legend: {
      position: "top",
    },
    title: {
      display: true,
      color: "#d7d1ff",
      text: "Option of Aging Asset (CAPEX and OPEX)",
    },
  },
};

function App({ assetId }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    const dataFilter = dataRaw[assetId];

    const labels = [];
    const datas = [
      dataFilter["Increase Maintenance"],
      dataFilter["Partial Refurbishment"],
      dataFilter["Replacement"],
    ];

    const data = {
      labels: ["Increase Maintenance", "Partial Refurbishment", "Replacement"],
      datasets: [
        {
          label: "Option of Aging Asset (CAPEX and OPEX)",
          data: datas,
          backgroundColor: "rgba(180,253,253,0.5)",
        },
      ],
    };
    setData(data);
  }, [assetId]);

  return data ? <Bar options={options} data={data} /> : null;
}
export default App;
